import React from 'react';
import '../../styles/NavBar.css';

const Navbar = () => {
  return (
    <nav className="navbar">
      <div className="left-side">
        <a href="/" className="logo-text">VIEWLY</a>
      </div>
      <div className="right-side">
        <a href="/search" aria-label="Search movies and TV shows">
          <i className='fas fa-magnifying-glass search-icon'></i>
        </a>
      </div>
    </nav>
  );
};

export default Navbar;
